/**
 * Wrapper component for SamsaraS3Video to bridge between class components and hooks.
 *
 * Hooks like useState/useEffect cannot be called inside class components, so if a class-based parent
 * needs to render SamsaraS3Video (which uses hooks internally), this function component acts as
 * a safe boundary for React to manage hook usage correctly.
 *
 */
import { FunctionComponent } from "react";
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes";
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types";
import SamsaraS3Video from "./SamsaraS3Video";

interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    configField?: boolean
    templateField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean
}

const SamsaraS3VideoWrapper: FunctionComponent<Props> = (props) => {
    return (
        <SamsaraS3Video {...props} />
    );
}

export default SamsaraS3VideoWrapper;